export function asObject(value) {
    return value && typeof value === "object" && !Array.isArray(value)
        ? value
        : {};
}
export function unwrapRequest(raw) {
    const obj = asObject(raw);
    const nested = obj.request;
    if (nested && typeof nested === "object" && !Array.isArray(nested)) {
        return nested;
    }
    return obj;
}
export function resolveSessionId(raw, fallback) {
    const obj = asObject(raw);
    return (typeof obj.sessionId === "string" ? obj.sessionId : undefined) || fallback;
}
export function createTelemetry(operationCount, startedAt) {
    return {
        operationCount,
        durationMs: Date.now() - startedAt,
        usedBackendFallback: false,
        timestamp: new Date().toISOString(),
    };
}
export function normalizeReadRequest(raw) {
    const normalized = { ...raw };
    if (raw.readContent?.length) {
        normalized.readContent = raw.readContent.map((item) => {
            const legacy = item;
            const targetRange = item.targetRange ||
                (typeof legacy.range === "string" ? legacy.range : undefined);
            const mode = item.mode ||
                (typeof legacy.mode === "string"
                    ? legacy.mode
                    : "structureWithFormulaPatternsAndValues");
            return {
                ...item,
                targetRange,
                mode,
            };
        });
    }
    const legacyListCharts = raw.listCharts;
    const canonicalReadCharts = raw.readCharts ? [...raw.readCharts] : [];
    if (Array.isArray(legacyListCharts) && legacyListCharts.length > 0) {
        for (const item of legacyListCharts) {
            const sheetName = typeof item?.sheetName === "string"
                ? item.sheetName
                : typeof item?.sheet_name === "string"
                    ? item.sheet_name
                    : "";
            if (!sheetName)
                continue;
            canonicalReadCharts.push({
                sheetName,
                dataMode: "auto",
            });
        }
    }
    if (canonicalReadCharts.length > 0) {
        normalized.readCharts = canonicalReadCharts;
    }
    return normalized;
}
export function isDetailedReadMode(mode) {
    return mode === "detailedValues" || mode === "detailedValuesAndFormulas";
}
export function mergeWarnings(target, source, opName) {
    if (!source?.length)
        return;
    for (const warning of source) {
        target.push(`${opName}: ${warning}`);
    }
}
export function mergeErrors(target, source, opName) {
    if (!source?.length)
        return;
    for (const error of source) {
        target.push(`${opName}: ${error}`);
    }
}
export function summarizeBucket(value) {
    if (Array.isArray(value)) {
        return `array(len=${value.length})`;
    }
    if (value && typeof value === "object") {
        const keys = Object.keys(value);
        return `object(keys=${keys.slice(0, 8).join(",")}${keys.length > 8 ? ",..." : ""})`;
    }
    return String(value);
}
